import React from "react"
import ActivityIndicator from "./ActivityIndicator"

const Loading = ({ label = "Loading...", style = {} }) => {
  return (
    <div style={{ ...style, padding: "1rem" }}>
      <ActivityIndicator label={label} />
    </div>
  )
}

export default Loading
